import {Translate} from "components/common/Translate/Translate";
import {ZipIcon} from "components/common/Icons/ZipIcon";
import {LightningFastIcon} from "components/common/Icons/LightningFastIcon";
import {PrivacyGuaranteedIcon} from "components/common/Icons/PrivacyGuaranteedIcon";
import {HeartIcon} from "components/common/Icons/HeartIcon";
import {ContentParent} from "components/modules/Content/ContentParent";
import {ContentItem} from "components/modules/Content/ContentItem/ContentItem";
import {BadgeIcon} from "components/common/Icons/BadgeIcon";
import {ImageFormatsIcon} from "components/common/Icons/ImageFormatsIcon";
import {Award, FileStack, Gift, HeartHandshake, Lightbulb, PencilRuler, ShieldCheck, Zap} from "lucide-react";

export const PngCompressorFeaturesContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-quality-title" />}
                description={<Translate keyName="content-quality-sub-title" />}
                icon={<Award strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-smart-png-compression-title" />}
                description={<Translate keyName="content-smart-png-compression-sub-title" />}
                icon={<Lightbulb strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-fast-easy-title" />}
                description={<Translate keyName="content-fast-easy-sub-title" />}
                icon={<PencilRuler strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="content-batch-png-title" />}
                description={<Translate keyName="content-batch-png-sub-title" />}
                icon={<FileStack strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="content-completely-free-title" />}
                description={<Translate keyName="content-completely-free-sub-title" />}
                icon={<Gift strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-safe-and-secure-title" />}
                description={<Translate keyName="content-safe-and-secure-sub-title" />}
                icon={<ShieldCheck strokeWidth={1.5} width={30} height={30}/>}
            />
        </ContentParent>
    );
};
